export default "__VITE_ASSET__DpFnZvRu__"